"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendGrid = void 0;
__exportStar(require("./direct-attachment"), exports);
__exportStar(require("./entity-type"), exports);
__exportStar(require("./flags"), exports);
__exportStar(require("./handlers"), exports);
__exportStar(require("./in-app-notification"), exports);
__exportStar(require("./message"), exports);
__exportStar(require("./schedule-template"), exports);
__exportStar(require("./schedule"), exports);
__exportStar(require("./send"), exports);
__exportStar(require("./send-template"), exports);
__exportStar(require("./template"), exports);
__exportStar(require("./wayste-text-topics"), exports);
exports.SendGrid = __importStar(require("./sendgrid"));
__exportStar(require("./communication"), exports);
__exportStar(require("./mandatory"), exports);
__exportStar(require("./email-events"), exports);
//# sourceMappingURL=index.js.map